import React from 'react';

import { Outlet } from '@/js/libs/router';
import { Loader } from '@/js/libs/ui/src/V2';

import { useFeatureToggleContext } from 'src/modules/FeatureToggle/index.ts';
import Status from 'src/scenes/Status/index.ts';

// Deal Groups are the unlaunched half of the section - Reporting and Deals stay reachable on production,
// everything that authors a Deal waits for DEAL_GROUPS. The toggles arrive one request after the user
// does, so the route holds a loader rather than answering Not Found and then changing its mind.
export const DealGroupsRoute = React.memo(function DealGroupsRoute() {
  const { isDealGroupsEnabled, pending } = useFeatureToggleContext();

  if (pending) {
    return <Loader content />;
  }

  return isDealGroupsEnabled ? <Outlet /> : <Status.NotFound />;
});
